module.exports = __webpack_public_path__ + "img/8_55.e402df9a.png";